import React from 'react';
import { Box, Button, Chip } from '@mui/material';

interface ComparisonControlsProps {
    selectedVersionsCount: number;
    onCompare: () => void;
}

const ComparisonControls: React.FC<ComparisonControlsProps> = ({
    selectedVersionsCount,
    onCompare
}) => {
    if (selectedVersionsCount === 1) {
        return (
            <Box mb={2}>
                <Chip 
                    label="Select second version to compare" 
                    color="info" 
                    variant="outlined"
                />
            </Box>
        );
    }

    if (selectedVersionsCount === 2) {
        return (
            <Box mb={2}>
                <Button 
                    variant="contained" 
                    onClick={onCompare}
                    color="primary"
                >
                    Compare Configuration
                </Button>
            </Box>
        );
    }

    return null;
};

export default ComparisonControls;